(function () {
  if (window.__irInit) return;
  window.__irInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.ir-reveal, .ir-escena, .ir-pasos__linea');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('ir-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('ir-visible'); observer.unobserve(e.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) {
      if (el.dataset.irObs) return;
      el.dataset.irObs = '1';
      observer.observe(el);
    });
  }

  function initGaleria(root) {
    (root || document).querySelectorAll('[data-ir-galeria]').forEach(function (g) {
      if (g.dataset.irInit) return;
      g.dataset.irInit = '1';
      var main = g.querySelector('[data-ir-main]');
      g.querySelectorAll('[data-ir-thumb]').forEach(function (b) {
        b.addEventListener('click', function () {
          main.style.opacity = '0';
          setTimeout(function () {
            main.src = b.dataset.irThumb;
            main.srcset = b.dataset.irSrcset || '';
            main.style.opacity = '1';
          }, 150);
          g.querySelectorAll('[data-ir-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
          b.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var conComas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    var conPuntos = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    return (fmt || '{{amount}}')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, conPuntos)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount\s*\}\}/, conComas);
  }

  function initVariantes(root) {
    (root || document).querySelectorAll('[data-ir-producto]').forEach(function (box) {
      if (box.dataset.irInit) return;
      box.dataset.irInit = '1';
      var dataEl = box.querySelector('[data-ir-variantes]');
      if (!dataEl) return;
      var variantes = JSON.parse(dataEl.textContent);
      var fmt = box.dataset.irMoney;
      var inputs = box.querySelectorAll('[data-ir-opcion]');
      function actualizar() {
        var elegidas = [];
        box.querySelectorAll('[data-ir-grupo]').forEach(function (grp) {
          var c = grp.querySelector('input:checked');
          elegidas.push(c ? c.value : null);
        });
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === elegidas[i]; });
        });
        if (!v) return;
        document.querySelectorAll('[data-ir-variant-id]').forEach(function (inp) { inp.value = v.id; });
        document.querySelectorAll('[data-ir-precio]').forEach(function (p) { p.textContent = money(v.price, fmt); });
        document.querySelectorAll('[data-ir-antes]').forEach(function (p) {
          if (v.compare_at_price && v.compare_at_price > v.price) { p.textContent = money(v.compare_at_price, fmt); p.hidden = false; } else { p.hidden = true; }
        });
        document.querySelectorAll('[data-ir-comprar]').forEach(function (b) {
          b.disabled = !v.available;
          b.setAttribute('data-variant-id', v.id);
          var t = b.querySelector('[data-ir-btn-txt]');
          if (t) t.textContent = v.available ? b.dataset.irTxt : b.dataset.irAgotado;
        });
        if (v.featured_image && box.querySelector('[data-ir-main]')) {
          var thumb = box.querySelector('[data-ir-media-id="' + v.featured_media_id + '"]');
          if (thumb) thumb.click();
        }
        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        }
      }
      inputs.forEach(function (i) { i.addEventListener('change', actualizar); });
    });
  }

  function initSticky(root) {
    var bar = document.querySelector('[data-ir-sticky]');
    var ancla = document.querySelector('[data-ir-ancla-compra]');
    if (!bar || !ancla || bar.dataset.irInit) return;
    bar.dataset.irInit = '1';
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var pasado = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('ir-visible', pasado);
      });
    }).observe(ancla);
  }

  function initScrollTo(root) {
    (root || document).querySelectorAll('[data-ir-ir-a-compra]').forEach(function (b) {
      if (b.dataset.irInit) return;
      b.dataset.irInit = '1';
      b.addEventListener('click', function (ev) {
        var destino = document.querySelector('[data-ir-ancla-compra]');
        if (!destino) return;
        ev.preventDefault();
        destino.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      });
    });
  }

  function initCifras(root) {
    (root || document).querySelectorAll('[data-ir-count]').forEach(function (el) {
      if (el.dataset.irInit) return;
      el.dataset.irInit = '1';
      var fin = parseFloat(el.dataset.irCount);
      var dec = (el.dataset.irCount.split('.')[1] || '').length;
      if (reduce || !('IntersectionObserver' in window) || isNaN(fin)) return;
      el.textContent = (0).toFixed(dec);
      var obs = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        obs.disconnect();
        var t0 = null, dur = 1600;
        function paso(t) {
          if (!t0) t0 = t;
          var p = Math.min(1, (t - t0) / dur);
          var e = 1 - Math.pow(1 - p, 3);
          el.textContent = (fin * e).toFixed(dec);
          if (p < 1) requestAnimationFrame(paso); else el.textContent = el.dataset.irCount;
        }
        requestAnimationFrame(paso);
      }, { threshold: 0.4 });
      obs.observe(el);
    });
  }

  function initFaq(root) {
    (root || document).querySelectorAll('.ir-faq__item').forEach(function (it) {
      if (it.dataset.irInit) return;
      it.dataset.irInit = '1';
      var q = it.querySelector('.ir-faq__q');
      q.addEventListener('click', function () {
        var abierto = it.classList.toggle('ir-abierto');
        q.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  function initMagnetico(root) {
    if (reduce || window.matchMedia('(hover: none)').matches) return;
    (root || document).querySelectorAll('.ir-magnetico').forEach(function (b) {
      if (b.dataset.irInit) return;
      b.dataset.irInit = '1';
      var f = parseFloat(b.dataset.irFuerza || '6');
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width - 0.5) * 2 * f;
        var y = ((e.clientY - r.top) / r.height - 0.5) * 2 * f;
        b.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
  }

  function initTodo(e) {
    var root = e && e.target && e.target.querySelectorAll ? e.target : document;
    initReveals(root); initGaleria(root); initVariantes(root); initSticky(root);
    initScrollTo(root); initCifras(root); initFaq(root); initMagnetico(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo);
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
